import { Box, Divider, Grid } from "@mui/material";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";

interface Props {
  handleBack: () => void;
  handleNext?: () => void;
  nextLoading?: boolean;
  nextDisabled?: boolean;
  nextWording?: string | JSX.Element;
  nextIcon?: string;
}
const StepperFooter = ({
  handleBack,
  handleNext,
  nextDisabled,
  nextLoading,
  nextWording = "Next",
  nextIcon = "fa-regular fa-arrow-circle-right",
}: Props) => {
  return (
    <>
      <Divider sx={{ my: 3 }} />

      <Grid
        container
        sx={{ px: 3, pb: 3, display: "flex", justifyContent: "center", gap: 2 }}
      >
        <StyledLargeButton onClick={handleBack} color="secondary">
          Back
        </StyledLargeButton>
        {handleNext && nextWording && (
          <StyledLargeButton
            loading={nextLoading}
            disabled={nextDisabled}
            styles={{ px: 6 }}
            onClick={handleNext}
          >
            {nextWording}
            <Box component="i" className={nextIcon} sx={{ ml: 1 }} />
          </StyledLargeButton>
        )}
      </Grid>
    </>
  );
};

export default StepperFooter;
